import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

/* Shared mobile presentation prefs. The one that matters most is the selected
   PLAY CURRENCY (coins | cash) — the design's top-bar currency switcher re-tints
   stakes, tiles and the slip everywhere, so it must be shared across the mobile
   layer (the desktop keeps its own local per-component selection, unchanged).
   Persisted to localStorage so it survives reloads and viewport switches. */

const KEY = "pb_play_wallet";
const PrefsCtx = createContext(null);
export const useMobilePrefs = () => useContext(PrefsCtx);

function readCur() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "cash" || v === "coins" ? v : "coins";
  } catch { return "coins"; }
}

export function MobilePrefsProvider({ children }) {
  const [playCurrency, setCur] = useState(readCur);

  const setPlayCurrency = useCallback((c) => {
    const next = c === "cash" ? "cash" : "coins";
    setCur(next);
    try { localStorage.setItem(KEY, next); } catch { /* ignore */ }
  }, []);

  // Keep in sync if another tab/layer changes it.
  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setCur(readCur()); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const isCash = playCurrency === "cash";
  return (
    <PrefsCtx.Provider value={{ playCurrency, setPlayCurrency, isCash }}>
      {children}
    </PrefsCtx.Provider>
  );
}

export default MobilePrefsProvider;
